
    const data = {"name":"src/core/icons/reorder-horizontal","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M3 15h18v-2H3v2m0 4h18v-2H3v2m0-8h18V9H3v2m0-6v2h18V5H3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            